var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5905 16.1604H2.64246M14.5905 16.1604L15.3044 13.3041C15.4396 12.765 15.2633 12.1944 14.8481 11.8255L13.8438 10.9332M14.5905 16.1604H12.3502V17.2806C12.3502 17.4867 12.5175 17.654 12.7236 17.654H14.2171C14.4232 17.654 14.5905 17.4867 14.5905 17.2806V16.1604ZM2.64246 16.1604L1.92856 13.3041C1.7934 12.765 1.96963 12.1944 2.38483 11.8255L3.38921 10.9332M2.64246 16.1604H4.88272V17.2806C4.88272 17.4867 4.71544 17.654 4.50934 17.654H3.01583C2.80973 17.654 2.64246 17.4867 2.64246 17.2806V16.1604ZM3.38921 10.9332L4.13596 7.94616C4.13596 7.94616 6.37622 7.19941 8.61648 7.19941C10.8567 7.19941 13.097 7.94616 13.097 7.94616L13.8438 10.9332M3.38921 10.9332H13.8438M17.8578 11.307L18.5717 8.45065C18.7069 7.9115 18.5306 7.34098 18.1154 6.97208L17.1111 6.07971M17.8578 11.307H15.6176V12.4271C15.6176 12.6332 15.7848 12.8005 15.9909 12.8005H17.4844C17.6905 12.8005 17.8578 12.6332 17.8578 12.4271V11.307ZM17.8578 11.307L14.2171 11.2649M5.65213 6.97208L6.65652 6.07971M6.65652 6.07971L7.40327 3.0927C7.40327 3.0927 9.64353 2.34595 11.8838 2.34595C14.124 2.34595 16.3643 3.0927 16.3643 3.0927L17.1111 6.07971M6.65652 6.07971H17.1111",
    stroke: "#959EB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectsIcon);
export default __webpack_public_path__ + "static/media/objects-icon.16a8fd708b83ae6e715ba65e085029e6.svg";
export { ForwardRef as ReactComponent };